import Alert from "../Alert";

export const SWITCH_OUT_FUND_ERRORS = {
  NO_HOLDING: "NO_HOLDINGS",
  FUND_TERMINATED_DEEPLINK: "FUND_TERMINATED_DEEPLINK",
  FUND_TERMINATED: "FUND_TERMINATED",
};

export const SwitchOutUnavailableAlert = ({
  switchOutFundError,
  isOpen,
  onClose,
}) => {
  return (
    <Alert
      title={
        switchOutFundError === SWITCH_OUT_FUND_ERRORS.NO_HOLDING
          ? "No balance to switch"
          : switchOutFundError === SWITCH_OUT_FUND_ERRORS.FUND_TERMINATED_DEEPLINK
          ? "Fund terminated"
          : "Switching unavailable"
      }
      description={
        switchOutFundError === SWITCH_OUT_FUND_ERRORS.NO_HOLDING
          ? "This fund has no remaining balance to switch."
          : switchOutFundError ===
            SWITCH_OUT_FUND_ERRORS.FUND_TERMINATED_DEEPLINK
          ? "Any remaining balance will be processed according to the Fund Termination Notice."
          : "Switching is no longer available for this fund."
      }
      isOpen={isOpen}
      isCancel={false}
      btnTxt="OK"
      handleAction={onClose}
    />
  );
};
